import Tablesort from "tablesort";

// Extend Tablesort to hide empty rows
const getInnerText = (el, options) => (
  el.getAttribute(options.sortAttribute || 'data-sort') ||
  el.textContent ||
  el.innerText ||
  ''
);

Tablesort.prototype.sortTable = (function(original) {
  return function(header, update) {
    // Run original implementation
    original.call(this, header, update);

    // After sorting, apply empty-row hiding or restoring
    const tableBodies = this.table.tBodies;
    const column = header.cellIndex;

    console.log("[HideEmpty Option]: ", this.options.hideEmpty);

    for (let i = 0; i < tableBodies.length; i++) {
      const rows = tableBodies[i].rows;
      for (let j = 0; j < rows.length; j++) {
        const cell = rows[j].cells[column];
        const text = cell ? getInnerText(cell, this.options).trim() : "";

        if (this.options.hideEmpty && text === "") {
          rows[j].style.display = "none"; // hide empty
        } else {
          rows[j].style.display = ""; // always restore visibility otherwise
        }
      }
    }
  };
})(Tablesort.prototype.sortTable);

export default Tablesort;
